<div>
    <!-- Title -->
    <h3>{{'management.users.overview.title' | translate}}</h3>
    <hr>
    <app-search-user (selectedUser)="toProfile($event)"></app-search-user>
</div>
